/* storybook-check-ignore */
import { Button } from '@opendoor/bricks/core';
import { Listing } from 'declarations/exclusives/listing';
import { getListingPriceCents } from 'helpers/exclusives/listing';
import noop from 'lodash/noop';

export default function ImInterestedButton({
  isPrimary,
  listing,
}: {
  isPrimary: boolean;
  listing: Listing;
}) {
  const listingPriceCents = getListingPriceCents(listing);
  return (
    <Button
      as="a"
      minHeight="3rem"
      aria-label={null}
      analyticsName="cosmos-exclusives-hero-open-house-price-section-start-an-offer-button"
      variant="secondary"
      bg="neutrals0"
      style={{ borderColor: '#B6B6B6' }}
      href={`/exclusives/homes/${encodeURIComponent(listing.slug)}/make-offer`}
      onClick={noop}
      {...(isPrimary && {
        variant: 'primary',
        color: undefined,
        bg: undefined,
        borderColor: undefined,
      })}
    >
      {listingPriceCents
        ? `Start a contract for $${(listingPriceCents / 100).toLocaleString()}`
        : "I'm interested"}
    </Button>
  );
}
